module.exports = __webpack_public_path__ + "static/media/Chord-Personalities_Stars.77411949.png";